import { atom } from "recoil";
import { companyParams } from "../../assets/company";
import { CouponLookupModel } from "../../pages/api/type";

export const companyInfoState = atom<companyParams>({
    key: "companyinfo",
    default: {},
});

export const companyNameState = atom<string>({
    key: "companyname",
    default: "",
});

export const couponListState = atom<CouponLookupModel[]>({
    key: "couponlist",
    default: [],
});

// dev: dev-
export const isDevState = atom<boolean>({
    key: "isdev",
    default:
        window.location.origin.includes("dev-") ||
        window.location.origin.includes("test-") ||
        window.location.origin.includes("localhost")
            ? true
            : false,
});
